import {
  API_PATTERN,
  MAIN_URL,
  PORT,
  PORT_FOR_TRAINING,
} from "../../constants/constants";
import { fetchWithToken } from "../../interceptors/fetchInterceptor";
import { CLEAR_PATTERN, GET_PATTERN, POST_PATTERN } from "../types";
import { getTypeRequest, structuredData } from "./structuredDate";

export function postPattern(url, data, id) {
  return async (dispatch) => {
    const port = id === 10 || id === 11 ? PORT_FOR_TRAINING : PORT;

    await fetchWithToken(MAIN_URL + port + API_PATTERN + url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    dispatch({
      type: POST_PATTERN,
    });
  };
}

export function clearPattern() {
  return {
    type: CLEAR_PATTERN,
  };
}

export function getPattern(url, id) {
  return async (dispatch) => {
    const port = id === 10 || id === 11 ? PORT_FOR_TRAINING : PORT;

    const request = await fetchWithToken(MAIN_URL + port + API_PATTERN + url);
    const { typePattern, typeRequest } = getTypeRequest(url);

    if (request.status === 200) {
      const response = await request.json();
      const newDate = structuredData(response, typePattern, typeRequest, id);

      dispatch({
        type: GET_PATTERN,
        payload: newDate,
      });
    }
  };
}
